<template>
    <div>
        <b-modal id="modal_form"
                 ref="modal_form"
                 :title="modal_titulo"
                 :ok-title="modal_botao"
                 close-title="Fechar"
                 v-model="showModal"
                 :ok-disabled=form.errors.any()
                 @ok="onStoreAnulacao">
                 <form @submit.stop.prevent="onStoreAnulacao" @keydown="form.errors.clear($event.target.name)">
                     <b-row no-gutters>
                         <b-col>
                              <label>Data do termo</label>
                              <input type="text" placeholder="Data" class="form-control" v-mask="'##/##/####'" v-model="form.dt_termo">
                              <b-form-feedback v-text="form.errors.get('dt_termo')" v-if="form.errors.has('dt_termo')"></b-form-feedback>
                          </b-col>
                          <b-col>
                              <label>CFOP</label>
                              <multiselect v-model="cfopSelected"
                              :options="optionsLivCfop"
                              track-by="value"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('cfop_id')" v-if="form.errors.has('cfop_id')"></b-form-feedback>
                          </b-col>
                      </b-row>
                      <b-row>
                          <b-col>
                              <label>Observação</label>
                              <b-form-textarea name="obs"
                                               v-model="form.obs"
                                               placeholder="Observação"
                                               :rows="3"
                                               :max-rows="6">
                              </b-form-textarea>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>
                              * Automaticamente é inserido o texto "Este CTE Anula o CTE Original número ***".<br/>
                          </b-col>
                      </b-row>
                      <br/><br/>
                      <b>*Atenção as regras para o CFOP:</b><br/>
                      Se UF de início da prestação = UF de fim de prestação (ambas diferentes de "EX"):<br/>
                      <b>CFOP deve ser 1206</b>;<br/>
                      Se UF de início da prestação diferente da UF de fim da prestação (ambas diferentes de "EX"):<br/>
                      <b>CFOP deve ser 2206</b>;<br/>
                      Se UF de início ou fim de prestação = "EX":<br/>
                      <b>CFOP deve ser 3206</b>;<br/>
                 </form>
                <div slot="modal-footer" class="w-100">
                       <div class="float-left"><spinner v-if="loading" message="Gerando..."></spinner></div>
                       <div class="float-right">
                           <div class="float-left" v-if="this.errors_array.length>0">
                               <b-btn class="badge badge-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i></b-btn>

                                 <b-popover :show.sync="showPopover" target="popoverButton-sync" title="Erros Encontrados" data-html="true" placement="leftbottom">
                                   <table class="table" id="mais">
                                        <tbody>
                                            <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
                                               <td>
                                                 {{ item.erro }}
                                               </td>
                                           </tr>
                                       </tbody>
                                   </table>
                                 </b-popover>
                             </div>
                           <b-btn @click="showModal=false" variant="secondary">
                             Cancelar
                           </b-btn>
                           <b-btn @click="onStoreAnulacao($event)" variant="secondary" :disabled="isDisabled">
                             Gerar CTE
                           </b-btn>
                       </div>
                </div>
        </b-modal>
    </div>
</template>
<script>
import accounting from 'accounting'
export default {
components: {
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      showModal: false,
      showPopover: false,
      errors_array: [],
      optionsLivCfop: [],
      cfopSelected: [],
      form: new Form({
          doc_id: '',
          dt_termo: '',
          obs: '',
          cfop_id: ''
      }),
      helpForm: new Form({statusRecord: [], params: [], search: ''}),
      fields: [],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    cfopSelected(obj) {
        this.form.cfop_id = obj.value;
    },
},
methods: {
    onCreate(doc_id) {
        this.modal_titulo = "Gerar CTE Anulação";
        this.modal_botao = "Gerar CTE";
        this.modal_acao = "i";
        this.isDisabled = false;
        this.form.reset();
        this.cfopSelected = [];
        this.errors_array = '';
        this.errors_array = [];
        this.$parent.optionsLivCfop.forEach((obj)=>
        {
            this.optionsLivCfop.push({ label: obj.label, value: obj.value})
        })
        this.form.doc_id = doc_id;
        this.$refs.modal_form.show();
    },
    onStoreAnulacao() {
        this.loading = true;
        this.isDisabled = true;
        this.form.post('/api/cte/anulacao/store').then(response => {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
            else
            {
                this.$parent.onFilterReset();
            }
        })
        .catch(errors => {
            new ReturnApi(errors, this)
            this.errors_array = '';
            this.errors_array = [];
            for(var property in errors)
            {
              if(errors.hasOwnProperty(property))
              {
                 if(typeof(errors[property]) === 'object')
                 {
                 errors[property].forEach((obj)=>{
                    this.errors_array.push({erro: obj});
                 });
                 }
              }
            }
        });
    },
    formatNumber(value) {
        return accounting.formatNumber(value, 2, '.', ',')
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    },
    getCurrency: {
        get() {
            return this.$store.getters.currency;
        }
    },
}
}
</script>
